// Added by Sejune Oh on 2020-03-31
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, useRef } from 'react'
import { createStyles, Theme, makeStyles, useTheme } from '@material-ui/core'

// UI
import { SearchIcon } from '@/components/_primes/icons'
import { InputBase, IconButton, Paper, InputBaseProps } from '@/components/_primes/v2'

// Constants
import { GREY_COLOR } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface SearchInputProps extends InputBaseProps {
  /** 입력한 키워드로 검색 */
  onSearch?: (keyword: string) => void
  /** Default value */
  value?: string | number
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * 입력한 키워드로 검색을 하는 UI 입니다.
 */
const SearchInput: FC<SearchInputProps> = ({ 
  onSearch, inputProps, 
  value: defaultValue, 
  onKeyUp: handleKeyUp, 
  ...rest 
}) => {
  const classes = useStyles(useTheme())
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (!onSearch) return 

    const curValue = inputRef.current!.value
    onSearch(curValue as string)
  }
  
  return (
    <div className={classes.wrapper}>
      <Paper className={classes.bgPaper} elevation={1}>
        <InputBase
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{
            ref: inputRef,
            'aria-label': 'search',
            onKeyUp: handleKeyUp,
            defaultValue: defaultValue,
            ...inputProps,
          }}
          {...rest}
        />
        <IconButton aria-label="Search" className={classes.searchIcon} onClick={handleClick}>
          <SearchIcon />
        </IconButton>
      </Paper>
    </div>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      height: '36px',
      width: '100%'
    },
    bgPaper: {
      backgroundColor: `${GREY_COLOR}`,
      padding: '6px 0 6px 12px',
      display: 'flex',
      flex: 1,
      alignItems: 'center',
    },
    searchIcon: {
      padding: '6px',
    },
    inputRoot: {
      color: 'inherit',
      flex: 1
    },
    inputInput: {},
  })
)

export default SearchInput
